define('views/pages/trade/offer/table',['require','jquery','underscore','models/base/model','views/base/view','text!templates/pages/trade/offer/table.ejs','text!templates/pages/trade/offer/table-row.ejs','text!templates/pages/trade/offer/rate-chart.ejs','ejs','lib/utils'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Model = require('models/base/model'),
        View = require('views/base/view'),
        templateTable = require('text!templates/pages/trade/offer/table.ejs'),
        templateTableRow = require('text!templates/pages/trade/offer/table-row.ejs'),
        templateRateChart = require('text!templates/pages/trade/offer/rate-chart.ejs'),
        ejs = require('ejs'),
        utils = require('lib/utils');


    var ExpertRatings = Model.extend({
        urlPath: '/expert-ratings',

        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            params.idOrganizationOffer = this.get('idOrganizationOffer');
            return params;
        }
    });

    var ContentView = View.extend({
        autoRender: true,
        template: templateTableRow,
        listen: {
            'afterLoad model': 'render',
            'change:viewData model': 'render',
            'change:loading model': 'render'
        },
        destroyTooltip: function(){
            this.$('[data-toggle="tooltip"]').tooltip('destroy');
            // this.$('.trade-table-freshness').tooltip('destroy');
            // this.$('.trade-table-quality').tooltip('destroy');
        },
        render: function() {
            this.destroyTooltip();

            View.prototype.render.apply(this, arguments);

            this.$('[data-toggle="tooltip"]').tooltip({ container: 'body', placement: 'bottom' });
            // this.$('.trade-table-freshness').tooltip({ container: 'body', placement: 'bottom' });
            // this.$('.trade-table-quality').tooltip({ container: 'body', placement: 'bottom' });
        },
        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        }
    });

    var TradeOfferTableView = View.extend({
        autoRender: true,
        region: 'trade-offer-table',
        template: templateTable,
        listSelector: 'tbody',
        listen: {
            'change:currentFilter model': 'updateScrollData',
            'change:loading model': 'onChangeLoading'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.subscribeEvent('selectBasketRow', this.onSelectBasketRow);

            this.delegate('click', '.trade-table-row', this.clickRow);
            this.delegate('click', '.trade-table-row button', this.clickMinlot);
            this.delegate('click', '.trade-table-row .trade-table-name a', this.clickCard);
            this.delegate('click', '.trade-table-row .trade-table-rateexp a', this.clickRate);
            this.delegate('click', '.trade-table-row .trade-table-seller a', this.clickSellerOrganization);
        },
        onChangeLoading: function() {
            this.$('tbody')[({ true: 'addClass', false: 'removeClass' })[this.model.get('loading')]]('preloader');
        },
        render: function() {
            var height, top;

            if (this.$list) {
                height = this.$list.css('height');
                top = this.$list.scrollTop();
            }

            View.prototype.render.apply(this, arguments);

            this.$list = this.$(this.listSelector);

            var view = new ContentView({ model: this.model, el: this.$list[0] });
            this.subview('content', view);

            if (height) {
                this.$list.css('height', height);
                this.$list.scrollTop(top);
            }

            this.$list.on('scroll', _.bind(this.onScroll, this));
            this.$list.on('mousewheel', _.bind(this.onMouseWheel, this));

            this.destroyPopover();
        },
        onSelectBasketRow: function(itemB) {
            var found, item, items;

            items = this.model.get('items');

            found = _.findWhere(items, {
                id: itemB.get('idTradeGoods'),
                idOrganizationOffer: itemB.get('idOrganizationOffer')
            });

            if (found) {
                item = _.findWhere(items, { selected: true });
                if (item && item !== found) {
                    item.selected = false;
                    this.updateItemSelection(item);
                }
                found.selected = true;
                this.updateItemSelection(found);
            }
        },
        onMouseWheel: function(ev) {
            ev.stopPropagation();
            ev.preventDefault();

            this.$list.scrollTop(this.$list.scrollTop() - ev.originalEvent.wheelDelta);
        },
        onScroll: function() {
            if (this.$list) {
                var top = this.$list.scrollTop();
                var height = this.$list.height();
                this.model.onScroll(top, height);
            }
            this.destroyPopover();
        },
        updateScrollData: function() {
            if (this.$list) {
                this.model.updateData();
                this.$list.scrollTop(0);
            }
        },
        updateItemSelection: function(item) {
            this.$('.trade-table-row[data-idx=' + item.idx + ']')[ item.selected ? 'addClass' : 'removeClass']('active');
        },
        clickRow: function(ev) {
            // ev.stopPropagation();
            // ev.preventDefault();

            var $el = $(ev.currentTarget);
            var idx = $el.data('idx');
            var items = this.model.filter.get('source');

            var item = _.findWhere(items, { selected: true });
            if (item && item.idx !== idx) {
                item.selected = false;
                this.$('.trade-table-row[data-idx=' + item.idx + ']').removeClass('active');
            }

            item = items[idx];

            item.selected = true;
            $el.addClass('active');

            this.publishEvent('selectTradeRow', item);

            if (this.clicked === 'card') {
                this.publishEvent('openOrgOfferCard', new Model(item));
            }

            if (this.clicked === 'minLot') {
                this.publishEvent('addToBasketMinLot', item);
            }

            if (this.clicked === 'rate') {
                this.destroyPopover();

                var model = new ExpertRatings({ idOrganizationOffer: item.idOrganizationOffer });

                $el = $($el.find('.trade-table-rateexp'));

                model.fetch().complete(function() {
                    var options = {
                        title: 'Оценка эксперта <button style="padding-left: 8px;" type="button" class="close" aria-hidden="true" data-action="cancel">×</button>',
                        placement: 'right',
                        template: '<div class="popover popover-black no-max-width"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-inner"><div class="popover-content"></div></div></div>'
                    };
                    utils.popover($el, options, ejs.render(templateRateChart, model.toJSON()));
                });
            }

            this.clicked = null;
        },
        clickMinlot: function(){
            this.clicked = 'minLot';
        },
        clickCard: function() {
            this.clicked = 'card';
        },
        clickRate: function() {
            this.clicked = 'rate';
        },
        clickSellerOrganization: function(){
            this.clicked = 'seller';
        },
        destroyPopover: function() {
            this.$('.trade-table-row .trade-table-rateexp').popover('destroy');
        },
        dispose: function() {
            if (this.disposed) {
                return;
            }

            this.destroyPopover();

            View.prototype.dispose.apply(this, arguments);
        }
    });

    return TradeOfferTableView;
});

